import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Get entity details by pro.
 *
 * @param dispatch
 * @param commit
 * @param payload {resource, id, state}
 * @returns {*}
 */
export function getEntityDetails(_ref, payload) {
  var dispatch = _ref.dispatch,
    commit = _ref.commit;
  return dispatch('api', {
    url: payload.resource + '/' + payload.id,
    params: _objectSpread(_objectSpread({}, payload.params), {}, {
      include_details: 1
    }),
    wait: 'entity-details'
  }, {
    root: true
  }).then(function (response) {
    if (payload.state) {
      commit('SET', {
        state: payload.state,
        data: response.data.data
      });
    }
    return response;
  });
}

/**
 * Clear defined state.
 *
 * @param commit
 * @param state
 */
export function clear(_ref2, state) {
  var commit = _ref2.commit;
  commit('CLEAR', state);
}